import type { Action } from './actions'
import type { OperationDeviceCoupon, OperationRepeat } from 'shared/types'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = {
    coupons: Array<OperationDeviceCoupon>,
    showTuto: boolean,
    legalMentionsRoute?: string,
    error?: any,
    networkError?: any,
    operationRepeat: OperationRepeat
}

const initialState: State = {
    coupons: [],
    showTuto: true,
    operationRepeat: {
        code: '', //Code de l'opération,
        name: '', // Correspond au nom de l'opération utilisé directement pour les textes, a détailler et confirmer...
        legalNotice: '', //Blob en BO pour permttre de contribuer des mentions légales très grande
        backgroundImage: [], //Correspond au fond qui est visible derrière les coupons
        actionTutorialLabel: '', //Correspond auCTa situé en dessous des coupons et qui renvoie vers le tutoriel
        actionLegalNoticeLabel: '', //Correspond au lien qui renvoie vers les mentions légales
        promotionLabel: '', //Correspond à la promotion référencée par le coupon "Valable pour 1 Démocratique Burger"
        burnedLabel: '', //Correspond au label à afficher lorsque le coupon a été burné,
        imageUrl: '', //Correspond à l'image de l'opération,
        operationPrice: 0 //Correspond au prix de la promotion
    }
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_HOMEPAGE_RESPONSE':
            const { marketingAnimations } = action.data
            const find =
                marketingAnimations &&
                marketingAnimations.primary &&
                marketingAnimations.primary.find(e => {
                    return !!e.operationRepeat
                })
            const operationRepeatPrimary = find
                ? find.operationRepeat
                : undefined
            const operationRepeatWidget =
                marketingAnimations && marketingAnimations.widget
                    ? marketingAnimations.widget.operationRepeat
                    : undefined
            const operationRepeat =
                operationRepeatPrimary || operationRepeatWidget
            return {
                ...state,
                operationRepeat
            }
        case 'GENERIC_SET_OPERATION_REPEAT':
            return { ...state, operationRepeat: action.operationRepeat }
        case 'PAGE_DATA_GENERIC_OPERATION_RESPONSE':
            return {
                ...state,
                ...action.data,
                showTuto: false,
                networkError: undefined,
                error: undefined
            }
        case 'GENERIC_OPERATION_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.pages.operation.root
            )

        default:
            return state
    }
}
